import styled from 'styled-components';

import { mediaTiny, mediaWide } from '@xingternal/layout-tokens';
import { spaceL, spaceM } from '@xingternal/tokens';

export const ActionsWrapper = styled.div<{ $alignment: 'vertical' | 'horizontal' }>`
  display: flex;
  flex-direction: ${({ $alignment }) => ($alignment === 'horizontal' ? 'row' : 'column')};
  gap: ${({ $alignment }) => ($alignment === 'horizontal' ? spaceM : 0)};
  align-items: flex-start;

  @media ${mediaWide} {
    gap: ${({ $alignment }) => ($alignment === 'horizontal' ? spaceL : 0)};
  }

  @media ${mediaTiny} {
    margin-top: 0;
  }
`;
